module.exports = __webpack_public_path__ + "static/Admin-Page-b355a28f8389a06f862dc007c1e5e232.jpg";